import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {SimplePresentation, SimplePresentationRunner} from "../winpresentation/SimplePresentationRunner";
import {DropInPresentation} from "../runnerpresentations/DropInPresentation";
import {CollapseAndFillPresentation} from "../runnerpresentations/CollapseAndFillPresentation";
import {TransformNinjaWildsPresentation} from "../runnerpresentations/TransformNinjaWildsPresentation";
import {TransformSushiWildsPresentation} from "../runnerpresentations/TransformSushiWildsPresentation";
import {WinAndRemovePresentation} from "../runnerpresentations/WinAndRemovePresentation";
import {KamisabiCollectPresentation} from "../runnerpresentations/KamisabiCollectPresentation";
import {KamisabiRemovePresentation} from "../runnerpresentations/KamisabiRemovePresentation";
import {SushiCollectPresentation} from "../runnerpresentations/SushiCollectPresentation";
import {SushiFreespinCollectPresentation} from "../runnerpresentations/SushiFreespinCollectPresentation";
import {ExitFreespinPresentation} from "../runnerpresentations/ExitFreespinPresentation";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class KitchenDramaSushiManiaWinPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        const presentations:SimplePresentation[] = [];

        for (let i:number = 0; i < KitchenDramaSushiMania.model.gameData.reels.length; i++){

            //Drop or fill
            if (i > 0){
                presentations.push(new CollapseAndFillPresentation(i))
            }

            //Transform wilds
            presentations.push(new TransformNinjaWildsPresentation(i));
            presentations.push(new TransformSushiWildsPresentation(i));

            //win pres remove
            presentations.push(new WinAndRemovePresentation(i));

            //Kamisabi update collection
            presentations.push(new KamisabiCollectPresentation(i));

            //Kamisabi remove
            presentations.push(new KamisabiRemovePresentation(i));

            //Sushi update collect
            presentations.push(new SushiCollectPresentation(i));

            //Sushi freespin update collect
            presentations.push(new SushiFreespinCollectPresentation(i));


        }

        presentations.push(new ExitFreespinPresentation());

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "WinPresRunner ");

    }


}